import { createSelector } from '@ngrx/store';

import {
  hasAtleastSubscriptionPlan,
  hasAtMostSubscriptionPlan,
  hasExactlySubscriptionPlan,
} from './account-subscription.helper';
import { PlanType, SubscriptionCheckType } from './account-subscription.model';
import { getAccountState } from './account.service';

export const selectAccountSubscription = createSelector(getAccountState, (account) => account?.subscription);

export const doPlanCheck = (plan: PlanType, checkType: SubscriptionCheckType = SubscriptionCheckType.AT_LEAST) =>
  createSelector(selectAccountSubscription, (accountSubscription): boolean => {
    switch (checkType) {
      case SubscriptionCheckType.AT_MOST:
        return hasAtMostSubscriptionPlan(plan, accountSubscription);
      case SubscriptionCheckType.EXACTLY:
        return hasExactlySubscriptionPlan(plan, accountSubscription);
      default:
        return hasAtleastSubscriptionPlan(plan, accountSubscription);
    }
  });

export const selectPlanIsAtleastBasic = doPlanCheck(PlanType.BASIC);
export const selectPlanIsAtleastPemium = doPlanCheck(PlanType.PREMIUM);
export const selectPlanIsAtleastEnterprise = doPlanCheck(PlanType.ENTERPRISE);
